import React, { lazy, Suspense } from 'react';
import { Router, Switch, Route } from 'wouter';
import Auth from '../auth/Auth';
import { ROUTES, ROOT_FOLDER } from '../constants/routes';
import Login from '../containers/Login';
import Logout from '../containers/Logout';
import StaticLoader from '../components/mui/MuiLoader/StaticLoader/StaticLoader';
import { AdviserFirmLocation } from '../components/adviser-firm-location';
import withTracker from '../components/with-tracker';

const Dashboard = lazy(() => import('../containers/Dashboard'));
const PolicyHolder = lazy(() => import('../containers/PolicyHolder'));
const PortalError = lazy(() => import('../containers/PortalError'));
const PortalLanding = lazy(() => import('../containers/PortalLanding'));
const PortalRedirect = lazy(() => import('../containers/PortalRedirect'));
const QI = lazy(() => import('../containers/QI'));
const ApplicationRoute = lazy(() => import('./ApplicationRoute'));
const AppError = lazy(() => import('../containers/Error'));
const PageNotFound = lazy(() => import('../containers/PageNotFound'));

const AuthRoute = (props) => {
  return (
    <Auth>
      <Route {...props} />
    </Auth>
  );
};

export const Routes = () => (
  <Suspense fallback={<StaticLoader />}>
    <AdviserFirmLocation />
    <Router>
      <Switch>
        <AuthRoute path={ROOT_FOLDER} component={Login} />
        <AuthRoute path={`${ROUTES.DASHBOARD}/:tab*`} component={Dashboard} />
        <AuthRoute path={ROUTES.QI} component={QI} />
        <AuthRoute path={ROUTES.APPLICATION} component={ApplicationRoute} />
        <AuthRoute path={ROUTES.POLICY_HOLDER} component={PolicyHolder} />
        <AuthRoute path={ROUTES.ERROR} component={AppError} />
        <AuthRoute path={ROUTES.PORTAL_REDIRECT} component={PortalRedirect} />
        <Route path={ROUTES.PORTAL_LANDING} component={PortalLanding} />
        <Route path={ROUTES.PORTAL_ERROR} component={PortalError} />
        <Route path={ROUTES.LOGOUT} component={Logout} />
        <Route path="/:rest*" component={PageNotFound} />
      </Switch>
    </Router>
  </Suspense>
);
export default withTracker(Routes);
